import useResource from './useResource';

const useAcademyEvents = ({ id }) => {
	const RESOURCE_URL = '/api/v1/admin/academy_events';

	const {
		resourceId: academyEventId,
		isLoading,
		isLoaded,
		isEmpty,
		isEditing,
		isValid,
		resource: academyEvent,
		resources: academyEvents,
		findOne: findAcademyEvent,
		findMany: findAcademyEvents,
		update: updateAcademyEvent,
		create: createAcademyEvent,
		save: saveAcademyEvent,
		destroy: deleteAcademyEvent,
		handleChange,
		clearResource,
		handleChangePage,
		uploadFile,
		deleteFile,
		reloadOne: reloadAcademyEvent,
		reloadMany: reloadAcademyEvents,
		query,
		page,
		paginate,
		numPages,
		perPage,
		totalCount,
		sortKey,
		sortDirection,
		handleSort,
		setResources: setAcademyEvents,
		setResource: setAcademyEvent
	} = useResource({
		id: id,
		url: RESOURCE_URL,
		name: 'event'
	});

	return {
		academyEventId,
		isLoading,
		isLoaded,
		isEmpty,
		isEditing,
		isValid,
		academyEvent,
		academyEvents,
		findAcademyEvent,
		findAcademyEvents,
		updateAcademyEvent,
		createAcademyEvent,
		saveAcademyEvent,
		deleteAcademyEvent,
		handleChange,
		clearResource,
		handleChangePage,
		uploadFile,
		deleteFile,
		reloadAcademyEvent,
		reloadAcademyEvents,
		query,
		page,
		paginate,
		numPages,
		perPage,
		totalCount,
		sortKey,
		sortDirection,
		handleSort,
		setAcademyEvents,
		setAcademyEvent
	};
};

export default useAcademyEvents;
